
import bg from '../assets/starbg.gif';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


export const themes = {
    light: {
        icon: DarkModeIcon,
        buttonColor: '#0080ff',
        chatBoxColor: 'white',
        backgroundColor: '#cccccc',
        inputColor: '#f3f3f5',
        chatTextColor: 'white',
        chatTextColor2: 'black',
        placeHolderTextColor: '#6d6f73',
        chatBubbleColor: '#f0f0f0',
        chatBubbleColor2: '#0080ff',
        bg: 'none',
        chatBoxStyling: {},
        inputStyling: {
            
        },
        chatBubbleStyling: {
            
        },
        chatBubbleStyling2: {
            
        },
    },
    dark: {
        icon: AutoAwesomeIcon,    
        buttonColor: '#0080ff',
        chatBoxColor: '#222222',
        backgroundColor: '#161616',
        inputColor: '#3a3b3c',
        chatTextColor: 'white',
        chatTextColor2: 'white',
        placeHolderTextColor: '#8a8c90',
        chatBubbleColor: '#4c4c4c',
        chatBubbleColor2: '#0080ff',
        bg: 'none',
        chatBoxStyling: {},
        inputStyling: {},
        chatBubbleStyling: {
            
        },
        chatBubbleStyling2: {
            
        },
        
    },
    campfire: {
        icon: LightModeIcon,
        buttonColor: 'white',
        chatBoxColor: 'white',
        backgroundColor: '#cccccc',
        inputColor: 'white',
        chatTextColor: 'white',
        chatTextColor2: 'white',
        placeHolderTextColor: '#6d6f73',
        chatBubbleColor: '#f0f0f0',
        chatBubbleColor2: '#0080ff',
        bg: `url(${bg})`,
        chatBoxStyling: {
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(5px)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
        },
        inputStyling: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)'
        },
        chatBubbleStyling: {
            backgroundColor: 'rgba(0, 128, 255, 0.5)'
        }
        ,
        chatBubbleStyling2: {
            backgroundColor: 'rgba(255, 255, 255, 0.3)'
        }
    }
  };